import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import type { AccountDeletionScope } from './useAccountDeletion'

const API_BASE_URL = import.meta.env.VITE_API_URL || ''

// EP-150 (App Review 5.1.1v): restore an account/login pending deletion, from
// the login page, with just the email and password the person typed there.
//
// Bare axios, not the authenticated `api` client: this call carries no token
// (the deletion request revoked it), so the interceptor's refresh/redirect
// machinery has nothing to work with. Same shape as useSignup / usePasswordReset.

export interface AccountRestorationInput {
  email: string
  password: string
}

export interface AccountRestorationResult {
  scope: AccountDeletionScope
  restored: true
}

export function useAccountRestoration() {
  return useMutation<AccountRestorationResult, unknown, AccountRestorationInput>({
    // The sign-in page shows the failure inside the panel.
    meta: { suppressErrorToast: true },
    mutationFn: async (input) => {
      const { data } = await axios.post<{ data: AccountRestorationResult }>(
        `${API_BASE_URL}/api/account_restoration`,
        input,
      )
      return data.data
    },
  })
}
